import React from 'react';
import { shape, string, func } from 'prop-types';
import Label from '@hig/label';
import Typography from '@hig/typography';
import "@hig/fonts/build/ArtifaktElement.css";

const PRIVATE_CLIENT = {
    value: "web",
    id: "app-type-web-radio-button",
    img: "//aps.autodesk.com/static/1.0.0.20251110232813/images/app-type-web.svg",
    width: "50px",
    title: "Traditional Web App",
    content: "Server-side web apps that can securely store secrets. Supports 2-legged and 3-legged authentication.",
    subtext: "Grant type: Authorization Code",
    name: "forge-apps-type"
}; 
const PUBLIC_CLIENT = {
    value: "native",
    id: "app-type-native-radio-button",
    img: "//aps.autodesk.com/static/1.0.0.20251110232813/images/app-type-native.svg",
    width: "50px",
    title: "Desktop, Mobile, Single-Page App",
    content: "Apps that run natively on a device or browser. Supports 3-legged authentication with PKCE.",
    subtext: "Grant type: PKCE",
    name: "forge-apps-type"
};
const CLIENT_CREDENTIALS = {
    value: "service",
    id: "app-type-service-radio-button",
    img: "//aps.autodesk.com/static/1.0.0.20251110232813/images/app-type-service.svg",
    width: "90px",
    title: "Server-to-Server App",
    content: "Server-side apps with no end user. Supports 2-legged authentication.",
    subtext: "Grant type: Client Credentials",
    name: "forge-apps-type"
};

export const AppTypeArr = [PRIVATE_CLIENT, PUBLIC_CLIENT, CLIENT_CREDENTIALS];
const titleText = (styles) => ({
    ...styles,
    typography: {
        ...styles.typography,
        fontFamily: "Artifakt Element, sans-serif !important",
        fontSize: "14px !important",
        lineHeight: "20px !important",
        fontWeight: "600 !important",
        margin: '15px auto 11px !important',
        color: "#3C3C3C !important",
        "@media screen and (max-width: 690px)": {
            fontSize: "16px !important",
            lineHeight: "22px !important",
            fontWeight: "500 !important",
            margin: '10px auto !important',
        }
    }

});

const contentText = (styles) =>  ({
    ...styles,
    typography: {
        ...styles.typography,
        fontFamily: "Artifakt Element, sans-serif",
        fontSize: "12px !important",
        fontWeight: "400 !important",
        lineHeight: "18px !important",
        margin: "10px !important",
        color: "#3C3C3C !important",
        "@media screen and (max-width: 690px)": {
            fontSize: "14px !important",
            lineHeight: "20px !important",
            margin: '0px auto !important',
            padding: "0px 20px !important"
        }
    }
});

export default function AppTypeRadioBtns({ appType, onClickMethod, selectedAppType }) {
    const { id, name, value, title, img, width, content } = appType;
    return (
        <div className="asdkf__forgeapp-app-type-radio-btn-container">
            <input className="asdkf__forgeapp-app-type-radio-btn" type="radio" id={id} value={value} name={name} onClick={onClickMethod} checked={selectedAppType === value} readOnly/>
            <div className="asdkf__forgeapp-app-type-radio-label-container">
                <Label htmlFor={id}>
                    <div className="asdkf__forgeapp-app-type-radio-label">
                        <img className="adskf__forgeapp-radio-label-img" src={img} style={{width: width}} />
                        <Typography align="center" variant="h3" stylesheet={titleText}>{title}</Typography>
                        <Typography align="center" variant="body" stylesheet={contentText}>{content}</Typography>
                    </div>
                </Label>
            </div>
        </div>
    );
}

AppTypeRadioBtns.propTypes = {
    appType: shape({
        id: string,
        name: string,
        value: string,
        title: string, 
        img: string,
        content: string,
        subtext: string,
    }),
    onClickMethod: func,
    selectedAppType: string
};
